// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedCenteringLeft_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s48IconSvg = html `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M29 15H7V35H41V15H43V37H5V13H29V15Z" class="svg-bg"/>
  <path d="M33 25C33 28.3137 35.6863 31 39 31C39.3407 31 39.6748 30.9716 40 30.917V32.9381C39.6724 32.979 39.3387 33 39 33C34.5817 33 31 29.4183 31 25C31 20.5817 34.5817 17 39 17C39.3387 17 39.6724 17.021 40 17.0619V19.083C39.6748 19.0284 39.3407 19 39 19C35.6863 19 33 21.6863 33 25Z" class="svg-bg"/>
  <path d="M40 22.1707C39.6872 22.0602 39.3506 22 39 22C37.3431 22 36 23.3431 36 25C36 26.6569 37.3431 28 39 28C39.3506 28 39.6872 27.9398 40 27.8293V22.1707Z" class="svg-bg"/>
  <path d="M34 3L28 8L34 13V9H43V7H34V3Z" fill="#EF8354"/>
</svg>
`;
const _s64IconSvg = html `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M39 25H10V51H54V25H56V53H8V23H39V25Z" class="svg-bg"/>
  <path d="M50 28C50.6849 28 51.3538 28.0689 52 28.2V30.252C51.3608 30.0875 50.6906 30 50 30C45.5817 30 42 33.5817 42 38C42 42.4183 45.5817 46 50 46C50.6906 46 51.3608 45.9125 52 45.748V47.8C51.3538 47.9311 50.6849 48 50 48C44.4772 48 40 43.5228 40 38C40 32.4772 44.4772 28 50 28Z" class="svg-bg"/>
  <path d="M50 34C50.7286 34 51.4117 34.1948 52 34.5351V41.4649C51.4117 41.8052 50.7286 42 50 42C47.7909 42 46 40.2091 46 38C46 35.7909 47.7909 34 50 34Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M45 8.49996L37 14.5L45 20.5V16L56.9999 16V13L45 13V8.49996Z" fill="#EF8354"/>
</svg>
`;
/**
 * IconMedCenteringLeft is a generated icon component.
 */
let IconMedCenteringLeft = IconMedCenteringLeft_1 = class IconMedCenteringLeft extends IconBaseElement {
    render() {
        return html `${IconMedCenteringLeft_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedCenteringLeft.icons = new Map([
    ['s8', _s48IconSvg],
    ['s12', _s48IconSvg],
    ['s16', _s48IconSvg],
    ['s24', _s48IconSvg],
    ['s32', _s48IconSvg],
    ['s40', _s48IconSvg],
    ['s48', _s48IconSvg],
    ['s64', _s64IconSvg],
    ['s72', _s64IconSvg],
    ['s80', _s64IconSvg],
]);
IconMedCenteringLeft = IconMedCenteringLeft_1 = __decorate([
    customElement('zui-icon-med-centering-left')
], IconMedCenteringLeft);
export { IconMedCenteringLeft };
